import { render, staticRenderFns } from "./Loot.vue?vue&type=template&id=08a173ce&scoped=true&"
import script from "./Loot.vue?vue&type=script&lang=js&"
export * from "./Loot.vue?vue&type=script&lang=js&"
import style0 from "./Loot.vue?vue&type=style&index=0&id=08a173ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a173ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VCard,VCardText,VCardTitle,VDivider,VIcon})
